import { getField, updateField } from "vuex-map-fields";
import { getSources, getTags, getSearchData } from "@/plugins/api.js";
import { cookies } from "@/plugins/vueCookies";
const namespaced = true;
const getISODate = (interval) =>
  new Date(new Date() - (interval * 24 - 8) * 60 * 60 * 1000)
    .toISOString()
    .substring(0, 10); //GMT+0800 台北標準時間
const format = (value, substr, newSubstr) => {
  const stringReplace = (item) =>
    item.replace(new RegExp(substr, "g"), newSubstr);
  return Array.isArray(value)
    ? value.map((item) => stringReplace(item))
    : stringReplace(value);
};
const defaultState = () => ({
  maxDate: getISODate(2), // 2天
  minDate: getISODate(90 + 1), // 90天，起始日當天也要算，故 +1 天
  sources: [],
  tags: [],
  // formCalendar: false,
  overview: {
    radioValue: 7,
    customizedDate: [],
    dates: [],
    visitors: [],
    sources: [],
    tag: "",
  },
  customanalysis: {
    radioValue: 7,
    customizedDate: [],
    dates: [],
    visitors: [],
    source: "",
    tag: "",
  },
  taganalysis: {
    radioValue: 7,
    customizedDate: [],
    dates: [],
    visitors: [],
    source: "",
    tag: "",
  }
  ,
  // clickCount:0,
  


  moduleType: "", //模組類型
});
const state = defaultState();


const mutations = {
  //表單雙向綁定
  updateField,

  setModuleType: (state, type) => state.moduleType = type, //設定模組類型

  resetState: (state) => Object.assign(state, defaultState()),
  // 日曆初始日
  setCalendar: (state) => {

    
    state[state.moduleType].customizedDate = format(
      [state.minDate, state.maxDate],
      "-",
      "/"
    );
  
    state[state.moduleType].dates = format([getISODate(state[state.moduleType].radioValue + 1), state.maxDate], "-", "/"); //起始日當天也要算，故+1天
    
  },
  //篩選條件 sources 設定
  setSources: (state, sourcesData) =>
    (state.sources = [...sourcesData.data.result.data]),
  //篩選條件 tags 設定
  setTags: (state, tagsData) =>
  (state.tags = [
    { id: "all", name: "不分標籤" },
    ...tagsData.data.result.data,
  ]),
  // 總覽自定義日期
  setCustomizedDate: (state, date) => {
    state[state.moduleType].customizedDate = date
  },
  // 總覽、單日表單日期
  setDate: (state, { date }) => {
    const dateArrange = (date) =>
      Array.isArray(date)
        ? format(date, "-", "/")
        : format([date, date], "-", "/");
    
      state[state.moduleType].dates = dateArrange(date);
      if(state[state.moduleType].dates.length<2){
        state[state.moduleType].dates.push(state[state.moduleType].dates[0])
      }
  },
  // 總瀏覽次數圖表點擊後更新單日表單
  // updateSingledayForm: (state, { source, date }) =>
  //   Object.assign(state.singleday, {
  //     dates: [date, date],
  //     visitors: state[state.moduleType].visitors,
  //     source: state.sources.find((obj) => obj.name === source).source,
  //     tag: state[state.moduleType].tag,
  //   }),
  resetClickCount:()=>(state.clickCount=0)
};
const actions = {
  initState: async ({ dispatch, commit, }, type) => {
    commit("setModuleType", type)
    
    commit("setCalendar");
    // commit("recentDate",state[state.moduleType].radioValue)
    // }
    const token = cookies.get("token");
    const [sourcesData, tagsData] = await Promise.all([
      getSources(token),
      getTags(token),
    ]);
    
    
    
    if (Object.keys(sourcesData.data.result).length < 1) {
      return dispatch(`user/tokenTimeout`, null, { root: true });
    }
    
    
    commit("setSources", sourcesData);
    commit("setTags", tagsData);
  },





  //new overview
  searchOverviewData: async ({ dispatch, commit, state },) => {
    const token = cookies.get("token");
    const requestParm = (form) => {
      const { dates, visitors } = form;
      const tag = "all"
      return form.sources.map((source) =>
        getSearchData({ dates, visitors, tag, source, token })
      );

    };
    const data = await Promise.all(requestParm(state[state.moduleType]))
    if (Object.keys(data[0].data.result).length < 1) {
      return dispatch(`user/tokenTimeout`, null, { root: true });
    }
    var sourceName;
    sourceName = (form, sourceList) =>
      form.sources.map((source) => {
        const { name = "" } = sourceList.find((item) => item.source === source);
        return name;
      });
    commit(`overview/setSources`, sourceName(state.overview, state.sources), { root: true, });
    dispatch(
      `overview/setOriginData`,
      data.map((el) => el.data.result),
      { root: true }
    );


  },
















  // searchOverviewData: async ({ dispatch, commit, state }) => {
  //   const token = cookies.get("token");
  //   const requestParm = (form) => {
  //     const { dates, visitors, tag } = form;

  //     console.log(tag)
  //     return form.sources.map((source) =>
  //       getSearchData({ dates, visitors, tag, source, token })
  //     );
  //   };

  //   const data = await Promise.all(requestParm(state.overview));
  //   if (Object.keys(data[0].data.result).length < 1) {
  //     return dispatch(`user/tokenTimeout`, null, { root: true });
  //   }




  //   const sourceName = (form, sourceList) =>
  //     form.sources.map((source) => {
  //       const { name = "" } = sourceList.find((item) => item.source === source);
  //       return name;
  //     });
  //   commit(`overview/setSources`, sourceName(state.overview, state.sources), {
  //     root: true,
  //   });

  //   var selectedTag = 0;
  //   state.tags.map((el) => {
  //     if (el.id === state.overview.tag) {
  //       selectedTag = el.name;
  //     } else {
  //       return null;
  //     }
  //   });
  //   //將選到的tag傳給singleday.js
  //   dispatch(`overview/setSelectedTag`, selectedTag, { root: true });
  //   dispatch(
  //     `overview/setOriginData`,
  //     data.map((el) => el.data.result),
  //     { root: true }
  //   );

  // },




  searchSingleSourceData: async ({ state, dispatch,commit }, req) => {
    var searchData;
    if (req == "customanalysis") {
      searchData = {
        ...state.customanalysis,
        token: cookies.get("token"),
      }
    } else if (req == "taganalysis") {
      searchData = {
        ...state.taganalysis,
        token: cookies.get("token"),
      }
    }
    const { data } = await getSearchData(searchData);
  
    if (Object.keys(data.result).length < 1) {
      return dispatch(`user/tokenTimeout`, null, { root: true });
    }


    switch (req) {
      case "customanalysis":
        dispatch(`customanalysis/setOriginData`,
          data.result,
          { root: true });
        break;
      case "taganalysis":
        dispatch(`taganalysis/setOriginData`,
          data.result,
          { root: true });
        commit("resetClickCount")
        var selectedTag = 0;
        state.tags.map((el) => {
          if (el.id === state.taganalysis.tag) {
            selectedTag = el.name;
          } else {
            return null;
          }
        });
        // //將選到的tag傳給taganalysis.js

        dispatch(`taganalysis/setSelectedTag`, selectedTag, { root: true });
        // state.clickCount=0;
        break;
    }

    // const sourceName = (form, sourceList) =>
    // form.sources.map((source) => {
    //   console.log("form",form)
    //   const { name = "" } = sourceList.find((item) => item.source === source);
    //   return name;
    // });
    // commit(`customanalysis/setSources`, sourceName(state.customanalysis, state.source), { root: true, });



  },


  recentDate: ({ state, commit }, radioValue) => {
    const date =
      radioValue === 0
        ? state[state.moduleType].customizedDate
        : [getISODate(radioValue + 1), state.maxDate]; //起始當天也要算，故 +1 天
    commit("setDate", { date: date });
  },
  customizedDate: ({ commit }, dateObject) => {
    commit("setCustomizedDate", dateObject.date);
    
    commit("setDate", dateObject);
  },
};
const getters = {
  getField,
  getAPISources: (state) => state.sources, // sources
  getAPITags: (state) => state.tags, // tags
  getSingledayCalendar: (state) =>
    format(state.singleday.dates[1] || state.maxDate, "/", "-"),
  getCustomizedDate: (state) =>
    format(
      state[state.moduleType].customizedDate || [state.minDate, state.maxDate],
      "/",
      "-"
    ),
  getDateRange: (state) => (rangeType) => state[rangeType],

};

export default { namespaced, state, actions, mutations, getters };
